{
  "abort": {
    "action": "Afbreken",
    "description": "<p>De verkiezing wordt pas opgeslagen als je alle stappen doorlopen hebt. Weet je zeker dat je het aanmaken van de verkiezing wilt afbreken?</p>",
    "discard_input": "Verkiezing niet opslaan",
    "keep_input": "Annuleren",
    "title": "Niet opgeslagen wijzigingen"
  },
  "add": "Toevoegen: {name}",
  "add_first_election": "<p>Om Abacus in te richten voor het invoeren van telresultaten, heb je de volgende bestanden nodig:</p><ul><li>Verkiezingsdefinitie (krijg je van het centraal stembureau)</li><li>Kandidatenlijsten (krijg je van het centraal stembureau)</li><li>Overzicht stembureaus in jouw gemeente (voor GSB)</li></ul><p>Zorg dat de bestanden op deze computer staan voordat je verder gaat.</p>",
  "all_districts": "Alle kieskringen",
  "check_and_save": {
    "description": "Je gaat de volgende verkiezing toevoegen:",
    "title": "Controleren en opslaan"
  },
  "check_eml": {
    "candidates_description": "Het bestand <file>filename</file> bevat de kandidaten voor onderstaand kiesgebied:",
    "candidates_title": "Controleer kandidatenlijsten",
    "check_hash_instructions": "Controleer de volledige digitale vingerafdruk met de code die je van het centraal stembureau hebt ontvangen. Vul ter controle de twee afgeschermde delen hieronder in. Ga alleen verder als alle delen overeenkomen.",
    "election_description": "Het bestand <file>filename</file> bevat de instellingen voor de volgende verkiezing:",
    "election_title": "Controleer verkiezingsdefinitie",
    "error": {
      "description": "De ingevoerde vingerafdruk klopt niet. Controleer de vingerafdruk en probeer het opnieuw.",
      "title": "Onjuiste vingerafdruk"
    },
    "polling_station_title": "Controleer stembureaus"
  },
  "committee_category": {
    "choose": "Kies het type stembureau",
    "description": "Voor welk stembureau wil je deze verkiezing nu klaarzetten? Ga je Abacus voor GSB én CSB gebruiken? Zet dan eerst het GSB klaar, en doe daarna hetzelfde voor het CSB.",
    "title": "Type stembureau"
  },
  "configuration_not_finished": "De configuratie van Abacus is nog niet afgerond.",
  "create": "Verkiezing toevoegen",
  "district": "Kieskring",
  "election_category": {
    "title": "Type verkiezing"
  },
  "import_candidates_eml": "Importeer kandidatenlijsten",
  "import_election_eml": "Importeer verkiezingsdefinitie",
  "import_polling_station_eml": "Importeer stembureaus gemeente {location}",
  "invalid_candidates_definition": {
    "description": "Het bestand <file>filename</file> bevat geen geldige kandidatenlijsten. Kies een bestand met een geldige definitie.",
    "title": "Ongeldige kandidatenlijsten"
  },
  "invalid_election_definition": {
    "description": "Het bestand <file>filename</file> bevat geen geldige verkiezingsdefinitie. Kies een bestand met een geldige definitie.",
    "title": "Ongeldige verkiezingsdefinitie"
  },
  "invalid_polling_station_definition": {
    "description": "Het bestand <file>filename</file> bevat geen geldige lijst met stembureaus. Kies een ander bestand.",
    "title": "Ongeldig stembureaubestand"
  },
  "invalid_committee_category": "Ongeldig type stembureau",
  "location": "Gebied",
  "manage": "Verkiezingen beheren",
  "message": {
    "election_created": "Verkiezing {committee_category} {name} toegevoegd"
  },
  "no_elections_added": "Nog geen verkiezingen ingesteld",
  "not_ready_for_use": "Abacus is nog niet klaar voor gebruik",
  "number_of_voters": {
    "error": "Vul het aantal kiesgerechtigden in",
    "hint": "Ingelezen uit bestand met stembureaus"
  },
  "please_wait_for_coordinator": "Je kan als invoerder nog niks doen. Wacht tot de coördinator het systeem openstelt voor het invoeren van telresultaten.",
  "political_groups_added": "{num_groups} lijsten en {num_candidates} kandidaten",
  "polling_station_definition_does_not_match_election": {
    "description": "Het bestand <file>filename</file> bevat stembureaus voor een andere verkiezing. Controleer voor je verder gaat of de stembureaus juist zijn.",
    "title": "Afwijkende verkiezing"
  },
  "polling_stations": {
    "added": "{num} stembureaus",
    "check": {
      "description": "Het bestand <file>filename</file> bevat onderstaande stembureaus. Zie je een verschil met de vooraf gepubliceerde lijst? Je kan na het toevoegen van deze verkiezing stembureaus toevoegen, verwijderen of aanpassen.",
      "title": "Controleer stembureaus"
    },
    "show_all": "Toon alle {num} stembureaus",
    "skip_step": "Stap overslaan en stembureaus later toevoegen"
  },
  "select_gsb": {
    "error": "Gemeentelijk stembureau kan niet worden geselecteerd",
    "title": "Selecteer het gemeentelijk stembureau"
  },
  "singular": "verkiezing",
  "start_when_count_list_received": "Zodra je een proces-verbaal van een stembureau hebt gekregen kan je beginnen met invoeren.",
  "status": "Status",
  "title": {
    "details": "Details verkiezing",
    "finish_data_entry": "Invoerfase afronden",
    "overview": "Overzicht verkiezingen",
    "plural": "Verkiezingen",
    "singular": "Verkiezing"
  },
  "use_instructions_to_import_candidates_eml": "Je hebt van het centraal stembureau instructies gekregen waarmee je het bestand met de kandidatenlijsten kunt downloaden. Zet het bestand op deze computer en importeer het.",
  "use_instructions_to_import_eml": "Je hebt van het centraal stembureau instructies gekregen waarmee je de verkiezingsdefinitie kunt downloaden. Zet het bestand op deze computer en importeer het.",
  "use_instructions_to_import_polling_stations_eml": "Importeer het bestand met stembureaus. Heb je geen bestand met stembureaus? Je kan ze later nog handmatig invoeren. Sla deze stap dan over.",
  "voting_method_type": {
    "CSO": "Centrale stemopneming (CSO)",
    "CSO_description": "Op de verkiezingsdag wordt het aantal stemmen per lijst geteld. De stemmen op kandidaten worden door het gemeentelijke stembureau geteld.",
    "description": "Hoe worden stemmen voor de {election} in de gemeente {location} geteld? Het type stemopneming wordt bepaald door het college van burgemeester en wethouders (B&W) van de gemeente.",
    "DSO": "Decentrale stemopneming (DSO)",
    "DSO_description": "Op de verkiezingsdag tellen de stembureaus de stemmen per kandidaat",
    "title": "Type stemopneming in"
  },
  "wrong_candidates_definition": {
    "description": "Het bestand <file>filename</file> bevat kandidatenlijsten voor een andere kieskring. Kies een bestand met de kandidatenlijsten voor de juiste kieskring.",
    "title": "Verkeerde kandidatenlijsten"
  },
  "you_cannot_start_data_entry_yet": "Je kan nog geen telresultaten invoeren."
}
